import { createSlice } from "@reduxjs/toolkit"
import { SMS_AGENT_ANALYTICS } from "../../../../constants/reducer_names"

const initialState = {
    checked_column: [
        "Agent Name",
        "Received SMS",
        "Responded SMS",
        "Overdue",
        "Missed SMS",
        "Discarded SMS",
        "Transferred SMS",
        "Maximum SMS handling time",
        "Avg. SMS handling time",
        "Interactions from Customer",
        "Interactions from Agent",
        "Total Interactions",
        "Customer Satisfaction (%)"
    ] as any,
    checked_column2: [
        "Agent Name",
        "Avg. Response Time",
        "Avg. Handle Time (AHT)",
        "Maximum Handle Time",
        "Total ACW Time",
        "Avg. Hold Time",
        "First Chat Resolution (%)",
        "Customer Satisfaction (%)"
    ] as any,
    checked_column3: [
        "Agent Name",
        "Chat Type",
        "SL1",
        "SL2",
        "SL3",
        "SL4",
        "SL5",
        "SL6",
        "Total",
        "Overdue",
        "SLA Achieved (%)",
        "SLA Breached (%)"
    ] as any,
    titleMapper_ForDb: {
        "Agent Name": "agentName",
        "Received SMS": "receivedSMS",
        "Responded SMS": "respondedSMS",
        "Overdue": "Overdue",
        "Missed SMS": "missedSMS",
        "Discarded SMS": "discardedSMS",
        "Transferred SMS": "transferredSMS",
        "Maximum SMS handling time": "MaximumSmsHandling",
        "Avg. SMS handling time": "AverageSmsHandling",
        "Interactions from Customer": "InteractionWithCustomer",
        "Interactions from Agent": "InteractionWithAgent",
        "Total Interactions": "totalInteraction",
        "Customer Satisfaction (%)": "CustomerSatisfaction",
    } as any,
    titleMapper_ForDb2: {
        "Agent Name":"agentName",
        "Avg. Response Time":"averageResponseTime",
        "Avg. Handle Time (AHT)":"averageHandledTime",
        "Maximum Handle Time":"MaximumHandledTime",
        "Total ACW Time":"totalACWTime",
        "Avg. Hold Time":"averageHoldtime",
        "First Chat Resolution (%)":"firstChatResolution",
        "Customer Satisfaction (%)":"SentimentalScore"
    } as any,
    titleMapper_ForDb3: {
        "Agent Name":"agentName",
        "Chat Type":"ChatType",
        "SL1":"SL1",
        "SL2":"SL2",
        "SL3":"SL3",
        "SL4":"SL4",
        "SL5":"SL5",
        "SL6":"SL6",
        "Total":"Total",
        "Overdue":"Overdue",
        "SLA Achieved (%)":"SLAAchieved",
        "SLA Breached (%)":"SLABreached"
    } as any,
    updated_TableColumn: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },
        {
            title: 'Received SMS',
            dataIndex: 'receivedSMS',
            key: 'receivedSMS',
        },
        {
            title: 'Responded SMS',
            dataIndex: 'respondedSMS',
            key: 'respondedSMS',
        },
        {
            title: 'Overdue',
            dataIndex: 'Overdue',
            key: 'Overdue',
        },
        {
            title: 'Missed SMS',
            dataIndex: 'missedSMS',
            key: 'missedSMS',
        },
        {
            title: 'Discarded SMS',
            dataIndex: 'discardedSMS',
            key: 'discardedSMS',
        },
        {
            title: 'Transferred SMS',
            dataIndex: 'transferredSMS',
            key: 'transferredSMS',
        },
        {
            title: 'Interactions from Customer',
            dataIndex: 'InteractionWithCustomer',
            key: 'InteractionWithCustomer',
        },
        {
            title: 'Interactions from Agent',
            dataIndex: 'InteractionWithAgent',
            key: 'InteractionWithAgent',
        },
        {
            title: 'Total Interactions',
            dataIndex: 'totalInteraction',
            key: 'totalInteraction',
        },
        {
            title: 'Customer Satisfaction (%)',
            dataIndex: 'CustomerSatisfaction',
            key: 'CustomerSatisfaction',
        }
    ] as any,
    updated_TableColumn2: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },
        {
            title: 'Avg. Response Time',
            dataIndex: 'averageResponseTime',
            key: 'averageResponseTime',
        },
        {
            title: 'Avg. Handle Time (AHT)',
            dataIndex: 'averageHandledTime',
            key: 'averageHandledTime',
        },
        {
            title: 'Maximum Handle Time',
            dataIndex: 'MaximumHandledTime',
            key: 'MaximumHandledTime',
        },
        {
            title: 'Total ACW Time',
            dataIndex: 'totalACWTime',
            key: 'totalACWTime',
        },
        {
            title: 'Avg. Hold Time',
            dataIndex: 'averageHoldtime',
            key: 'averageHoldtime',
        },
        {
            title: 'First Chat Resolution (%)',
            dataIndex: 'firstChatResolution',
            key: 'firstChatResolution',
        },
        {
            title: 'Customer Satisfaction (%)',
            dataIndex: 'CustomerSatisfaction',
            key: 'CustomerSatisfaction',
        }
    ] as any,
    updated_TableColumn3: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },
        {
            title: 'Chat Type',
            dataIndex: 'ChatType',
            key: 'ChatType',
        },
        {
            title: 'SL1',
            dataIndex: 'SL1',
            key: 'SL1',
        },
        {
            title: 'SL2',
            dataIndex: 'SL2',
            key: 'SL2',
        },
        {
            title: 'SL3',
            dataIndex: 'SL3',
            key: 'SL3',
        },
        {
            title: 'SL4',
            dataIndex: 'SL4',
            key: 'SL4',
        },
        {
            title: 'SL5',
            dataIndex: 'SL5',
            key: 'SL5',
        },
        {
            title: 'SL6',
            dataIndex: 'SL6',
            key: 'SL6',
        },
        {
            title: 'Total',
            dataIndex: 'Total',
            key: 'Total',
        },
        {
            title: 'Overdue',
            dataIndex: 'Overdue',
            key: 'Overdue',
        },
        {
            title: 'SLA Achieved (%)',
            dataIndex: 'SLAAchieved',
            key: 'SLAAchieved',
        },
        {
            title: 'SLA Breached (%)',
            dataIndex: 'SLABreached',
            key: 'SLABreached',
        },
    ] as any
}

const agentAnalyticsSMSSlice = createSlice({
    name: SMS_AGENT_ANALYTICS,
    initialState,
    reducers: {
        checkedColumn: (state, { payload }) => {
            state.checked_column = payload.checked_column;
        },
        checkedColumn2: (state, { payload }) => {
            state.checked_column2 = payload.checked_column2;
        },
        checkedColumn3: (state, { payload }) => {
            state.checked_column3 = payload.checked_column3;
        },
        titleMapperForDb: (state, { payload }) => {
            state.titleMapper_ForDb = payload.titleMapper_ForDb;
        },
        titleMapperForDb2: (state, { payload }) => {
            state.titleMapper_ForDb2 = payload.titleMapper_ForDb2;
        },
        titleMapperForDb3: (state, { payload }) => {
            state.titleMapper_ForDb3 = payload.titleMapper_ForDb3;
        },
        updatedTableColumn: (state, { payload }) => {
            state.updated_TableColumn = payload.updated_TableColumn;
        },
        updatedTableColumn2: (state, { payload }) => {
            state.updated_TableColumn2 = payload.updated_TableColumn2;
        },
        updatedTableColumn3: (state, { payload }) => {
            state.updated_TableColumn3 = payload.updated_TableColumn3;
        },


    }
})

export const agentAnalyticsSMSSliceActions = agentAnalyticsSMSSlice.actions;
export const agentAnalyticsSMSSliceReducer = agentAnalyticsSMSSlice.reducer